import {filter, keys} from 'lodash-es'

///////////////////////////////////////////////////////////////////////////////

export const getKeysWithDifferentValues = (obj1: any, obj2: any) => {
  const allKeys = keys({...obj1, ...obj2})

  return filter(allKeys, k => obj1[k] !== obj2[k])
}
